/* eslint-disable react/prop-types */
import { Paper, Stack, Typography } from "@mui/material";

const AffiliatedCards = ({ count, count_two, name }) => {
  return (
    <Stack spacing={2}>
      <Typography
        variant="subtitle2"
        sx={{ fontSize: { xs: "13.59px", md: "14px" } }}
      >
        {name}
      </Typography>
      <Typography color="primary" variant="h3">
        {count}
      </Typography>
    </Stack>
  );
};

export default AffiliatedCards;
